<script lang="ts" setup>
  import { BngPageFooter } from '~/layouts/components'

  const { data: content } = await useAsyncData(() => queryCollection('content').path('/cgv').first())

</script>
<template>
  <div class="p-cgu">
    <Markdown :content="content" />
    <ContactBlock no-faq />
    <BngPageFooter />
  </div>
</template>
<style scoped>

.p-cgu {
  flex: 1 0 auto;
  padding: 1em;
  background-color: white;

  h1 {
    display: flex;
    flex-direction: row;
    margin-bottom: 1em;

    span {
      color: var(--color-secondary);
      font-family: Bariol, sans-serif;
      font-size: 1.5em;
      font-weight: bold;
    }
  }
}
</style>
